import { FC, useContext, useMemo, useState } from 'react'
import PopupContainer from 'src/component/popup/PopupContainer'
import { useGet } from 'src/hooks/useGet'
import { errorToaster, getHospitalConfiguralion } from 'src/utils'
import DynamisServiceCard, { RepeatedDoses, userDose } from './DynamisServiceCard'
import { useMutation } from 'src/hooks/useMutation'
import { GetHospitalsMedicines, GetParentHospitalConfiguration } from 'src/requests/Shared'
import { useLocation } from 'react-router-dom'
import { GetDecisionMedicineForUpdate, SubmitNewDecisionMedicines } from 'src/requests/DecisionMedicine'
import { Alert } from 'src/component/Alert'
import DataState from 'src/component/DataState/DataState'
import { Skeleton } from 'src/component/Skeleton/Skeleton'
import { hospitalConigurationType } from 'src/types/ContextsType/Privileges.Type'
import { patientDecisionMedicine } from 'src/types/DoctorScreens/DoctorOrders'

interface IMedicalServicesPopup {
    modalId: any
    hospitalId: number | null
    decisionId: number | null
    setDecisionId: Function
}

const medicalService = 'medicalService'

export const defaultItem = {
    allowsAllDurations: false,
    directAmount: "",
    doseCountPerTime: "1",
    dosePerDay: "1",
    duration: 1,
    durationType: RepeatedDoses[2],
    sDoseType: userDose[0],
    sMedicine: null,
    isNewItem: true
}
const CMedicialNotesPopup: FC<IMedicalServicesPopup> = ({ hospitalId, decisionId, modalId, setDecisionId }) => {
    const [data, setData] = useState<patientDecisionMedicine[]>([defaultItem])
    const [notAvailableMap, setNotAvailableMap] = useState<Record<number, boolean>>({})

    const { state } = useLocation()

    const { data: HospitalMedicine } =
        useGet({
            API: GetHospitalsMedicines,
            isNotValid: !hospitalId,
            depArr: [state?.pharmName?.value, hospitalId],
            params: [state?.pharmName?.value, hospitalId, true],
            defaultValue: []
        })

    const { data: DecisionMedicines, error, isError, isPending } = useGet({
        API: GetDecisionMedicineForUpdate,
        isNotValid: !decisionId,
        depArr: [decisionId],
        params: [decisionId],
        defaultValue: [],
    })

    const { data: hospitalConfiguration = [] } = useGet<hospitalConigurationType[]>({
        API: GetParentHospitalConfiguration,
        depArr: [hospitalId],
        params: [hospitalId],
        isNotValid: !hospitalId,
        defaultValue: [],
        needSpinner: true,
    })

    const isResritctMedicineAllDecisionPeriod = useMemo(
        () =>
            getHospitalConfiguralion(
                hospitalConfiguration,
                'ResritctMedicineAllDecisionPeriod'
            )?.isAllowed,
        [hospitalConfiguration]
    )

    const { mutate } = useMutation()

    const handleSubmit = () => {
        let isAnyEmpty = data?.some((item: patientDecisionMedicine) =>
            !item.sMedicine ||
            (!item.duration && !item.allowsAllDurations) || !item?.durationType ||
            !item.doseCountPerTime || !item?.dosePerDay ||
            !item.sDoseType || (item?.sMedicine?.allowDirectAmount && !item?.directAmount))

        const isNotAvalilable = Object.values(notAvailableMap).some(Boolean)

        if (isAnyEmpty && !DecisionMedicines.length) return errorToaster("add-item-atlist")
        if (isNotAvalilable) return errorToaster("isNotAvalilable")
        let dataList = data?.map(item => ({
            duration: item?.duration || 0,
            decisionId: decisionId,
            durationType: item?.durationType?.value,
            doseCountPerTime: item?.doseCountPerTime || 0,
            dosePerDay: item?.dosePerDay || 0,
            directAmount: item?.directAmount || 0,
            allowsAllDurations: item?.allowsAllDurations || false,
            doseTypeId: item?.sDoseType?.value,
            medicineId: item?.sMedicine?.value
        }))

        let requestBody = {
            decisionID: decisionId,
            medicines: [...dataList]
        }

        mutate({
            apiMethod: SubmitNewDecisionMedicines,
            body: requestBody,
            actionType: 'post',
            onSuccess: () => onSuccess(),
            name: "add-medicine",
        })
    }

    const onSuccess = () => {
        modalId.current.click()
        setData([defaultItem])
        setDecisionId(null)
    }
    const handleReset = () => {
        setData([defaultItem])
        setDecisionId(null)
    }
    return (
        <PopupContainer
            Name='add-medicine'
            modalID={modalId}
            modalName={medicalService}
            onApply={handleSubmit}
            resetAllFields={handleReset}
            isValidToSubmit={!isError}
        >
            {
                <DataState
                    key={hospitalId}
                    isEmpty={isError}
                    isLoading={isPending}
                    skeleton={<Skeleton height="100px" width="100%" />}
                    emptyState={
                        <Alert variant='danger' >
                            <span>{error}</span>
                        </Alert>
                    }
                >
                    <DynamisServiceCard
                        hospitalId={hospitalId}
                        decisionId={decisionId}
                        decisionMedicinesList={DecisionMedicines}
                        data={data}
                        setData={setData}
                        medicinesList={HospitalMedicine}
                        isResritctMedicineAllDecisionPeriod={isResritctMedicineAllDecisionPeriod}
                        setNotAvailableMap={setNotAvailableMap}
                    />
                </DataState>
            }
        </PopupContainer>
    )
}

export default CMedicialNotesPopup